import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      layout: "default"
    }
  },
  {
    path: '/eval',
    name: 'evaluate',
    component: () => import("../views/Evaluate.vue"),
    meta: {
      layout: "main"
    }
  },
  {
    path: '/report',
    name: 'report',
    component: () => import("../views/Report.vue"),
  },
  {
    path: '/error/:code',
    name: 'error',
    component: () => import('../views/Error.vue'),
    meta: {
      layout: "default"
    }
  },
  {
    path: '/encrypt',
    name: 'encrypt',
    component: () => import("../views/Encrypt.vue"),
    meta: {
      layout: "default"
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
